import styled from 'styled-components';
import { theme } from '../../../styles/theme';

interface IProps {
  amount: number;
}

const Container = styled.div`
  flex: 0 0 auto;
  width: 16px;
  height: 16px;
  border-radius: 50%;
  text-align: center;
  font-size: 8px;
  font-weight: 400;
  line-height: 15px;
  user-select: none;
  background-color: ${theme.colors.secondary300};
  color: ${theme.colors.secondary900};
`;

const ThreadIndicatorCounter = ({ amount }: IProps) => (
  <Container>{amount > 9 ? '9+' : `+${amount}`}</Container>
);

export default ThreadIndicatorCounter;
